import api from '../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormChecklistGroup from './Form/FormChecklistGroup'

function EditChecklistGroup({ id, btCancelAction, handleOnSuccess }) {
    const [checklistGroup, setChecklistGroup] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get(`/checklistGroup/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            setChecklistGroup(response.data.checklistGroup)
        })
    }, [token, id])

    async function updateChecklistGroup(checklistGroup) {
        let msgType = 'success'

        const data = await api.patch(`checklistGroup/update/${checklistGroup._id}`, checklistGroup, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            {checklistGroup._id && (
                <FormChecklistGroup
                    title="Editar Grupo de Checklist"
                    handleSubmit={updateChecklistGroup}
                    btnText="Salvar"
                    btCancelAction={btCancelAction}
                    checklistGroupData={checklistGroup}
                />
            )}
        </section>
    )
}

export default EditChecklistGroup
